const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MAX_SHORT = 80;
const MAX_MESSAGE = 500;

/**
 * @param {(key: string, opts?: object) => string} t
 * @returns {import("react-hook-form").Resolver<{
 *   fullName: string,
 *   email: string,
 *   phone: string,
 *   country: string,
 *   company: string,
 *   message: string,
 *   newsletter: boolean,
 * }>}
 */
export function createContactFormResolver(t) {
  return function contactFormResolver(values) {
    const fullName = String(values.fullName ?? "").trim();
    const email = String(values.email ?? "").trim();
    const phone = String(values.phone ?? "").trim();
    const country = String(values.country ?? "").trim();
    const company = String(values.company ?? "").trim();
    const messageRaw = String(values.message ?? "");
    const message = messageRaw.trim();
    const newsletter = Boolean(values.newsletter);

    /** @type {import("react-hook-form").FieldErrors<typeof values>} */
    const errors = {};

    if (!fullName) {
      errors.fullName = {
        type: "required",
        message: t("contact.valFullNameRequired"),
      };
    } else if (fullName.length > MAX_SHORT) {
      errors.fullName = {
        type: "maxLength",
        message: t("contact.valFullNameMax"),
      };
    }

    if (!email || !EMAIL_RE.test(email)) {
      errors.email = {
        type: "pattern",
        message: t("contact.valEmailInvalid"),
      };
    }

    if (!country) {
      errors.country = {
        type: "required",
        message: t("contact.valCountryRequired"),
      };
    } else if (country.length > MAX_SHORT) {
      errors.country = {
        type: "maxLength",
        message: t("contact.valCountryMax"),
      };
    }

    if (company.length > MAX_SHORT) {
      errors.company = {
        type: "maxLength",
        message: t("contact.valCompanyMax"),
      };
    }

    if (!message) {
      errors.message = {
        type: "required",
        message: t("contact.valMessageRequired"),
      };
    } else if (messageRaw.length > MAX_MESSAGE) {
      errors.message = {
        type: "maxLength",
        message: t("contact.valMessageMax"),
      };
    }

    if (Object.keys(errors).length > 0) {
      return { values: {}, errors };
    }

    return {
      values: {
        fullName,
        email,
        phone,
        country,
        company,
        message,
        newsletter,
      },
      errors: {},
    };
  };
}
